import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { chartActions } from '../../../store/charts/chartsStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';

import LockIcon from '../../../img/icons/Zamcene';
import UnlockIcon from '../../../img/icons/Odemcene';
import NiIcon from '../../../img/icons/ikona_negativni_informace';
import TimelineIcon from '../../../img/icons/ikona_vazby';
import SubjectListIcon from '../../../img/icons/ikona_seznam_subjektu';
import RelationToIcon from '../../../img/icons/ikona_k_subjektu';
import RelationFromIcon from '../../../img/icons/ikona_od_subjektu';
import RelationTwoWayIcon from '../../../img/icons/ikona_oba_smery';

import '../chartSettings.scss';

const BUTTONS = {
    level1: { content: "I.", title: "Charts.Level.1", textContent: true },
    level2: { content: "II.", title: "Charts.Level.2", textContent: true },
    level3: { content: "III.", title: "Charts.Level.3", textContent: true },
    level4: { content: "IV.", title: "Charts.Level.4", textContent: true },
    lock: { content: <LockIcon className='icon-centered' />, title: "Charts.BtnLockNodes.Text" },
    unlock: { content: <UnlockIcon className='icon-centered' />, title: "Charts.BtnUnlockNodes.Text" },
    negativeInfo: { content: <NiIcon className='icon-centered' />, title: "Charts.ShowWarningPictograms" },
    timeline: { content: <TimelineIcon className='icon-centered' />, title: "Charts.Timeline" },
    subjectList: { content: <SubjectListIcon className='icon-centered' />, title: "Charts.SubjectList" },
    relationsTo: { content: <RelationToIcon className='icon-centered' />, title: "Charts.LinkDirectionBackward" },
    relationsFrom: { content: <RelationFromIcon className='icon-centered' />, title: "Charts.LinkDirectionForward" },
    relationsTwoWay: { content: <RelationTwoWayIcon className='icon-centered' />, title: "Charts.LinkDirectionTwoWay" },
    sharePlus: { content: "+", textContent: true },
    shareMinus: { content: "-", textContent: true },
};

class ChartSettingsButton extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        toggled: PropTypes.bool,
        disabled: PropTypes.bool,
        action: PropTypes.func.isRequired
    };

    static defaultProps = {
        toggled: false,
        disabled: false
    };

    render() {
        const button = BUTTONS[this.props.type];
        if (isNullOrUndefined(button))
            return null;

        return (
            <div className={classnames("rc-button", { toggled: this.props.toggled, disabled: this.props.disabled })}
                onClick={this.props.action}
                title={isNullOrUndefined(button.title) ? undefined : this.props.translate(button.title)}
            >
                {button.textContent === true ? <span>{button.content}</span> : button.content}
            </div>
        );
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartSettingsButton)));